import Game from './Game';

export default Game;
